var $c03fe977fcfafe93$exports = {};
$c03fe977fcfafe93$exports = {
  "calendar": "Kalendarz",
  "day": "dzie\u0144",
  "dayPeriod": "rano / po po\u0142udniu / wieczorem",
  "endDate": "Data ko\u0144cowa",
  "era": "era",
  "hour": "godzina",
  "minute": "minuta",
  "month": "miesi\u0105c",
  "second": "sekunda",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Wybrana data: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Wybrany zakres: ".concat(args.startDate, " do ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Wybrany czas: ".concat(args.time);
  },
  "startDate": "Data pocz\u0105tkowa",
  "timeZoneName": "strefa czasowa",
  "weekday": "dzie\u0144 tygodnia",
  "year": "rok"
};
export { $c03fe977fcfafe93$exports as default };